<canvas 
  #colorPan
  class="color_panel"
></canvas>
<ion-range 
  #knob
  labelPlacement="stacked" 
  [style]="selectedColor"
  [disabled]="disabled"
  [min]="min"
  [max]="max"
  debounce="250"
  [(ngModel)]="selectedPosition"
  (ionKnobMoveStart)="onStartMove()"
  (ionKnobMoveEnd)="onChangeValue($event)"
></ion-range>
